import React, { useState } from 'react'

import { StyledParametersList } from './style'
import styled from 'styled-components'
import { getHashParametersFiltered } from './utils'
import useSetParamsToRouter from 'live/lib/hooks/useSetParamsToRouter'

interface ParametersListProps {
    parameter: any
}

const ParametersList = function ({
    dark,
    parameters,
    update,
    restoreDefault,
    pluginHeaderNavigationDetected,
    contextParams
}: ParametersListProps) {
    const [newParameters, setNewParameters] = useState(parameters.map(e => ({ ...e })))
    const setParamsToRouter = useSetParamsToRouter(true)

    // ParametersList.toggle = toggle

    function updateProperty(value: string, pos: number) {
        setNewParameters(p => [...p.slice(0, pos), { ...p[pos], value }, ...p.slice(pos + 1)])
    }

    const updateParametersOnHash = parameters => {
        let hashValues = getHashParametersFiltered(window.location.hash, contextParams)

        setParamsToRouter({
            ...contextParams,
            ...hashValues,
            'asset-parameters': encodeURIComponent(
                encodeURIComponent(JSON.stringify(parameters.map(({ priority, ...attrs }) => attrs)))
            )
        })
    }

    return (
        <StyledParametersList
            dark={dark}
            pluginHeaderNavigationDetected={pluginHeaderNavigationDetected}
            outsideClickIgnoreClass="parameters-button"
        >
            <ul>
                {newParameters.map(({ name, value }, i) => (
                    <li key={i}>
                        <label>{name}</label>
                        <input type="text" value={value} onChange={e => updateProperty(e.target.value, i)} />
                    </li>
                ))}
            </ul>
            <ParameterActions dark={dark}>
                <button
                    className="btn btn-primary btn-save"
                    onClick={() => {
                        updateParametersOnHash(newParameters)
                        update(newParameters)
                    }}
                >
                    Apply
                </button>
                {/*<Cancel onClick={restoreDefault}>Restore defaults</Cancel>*/}
            </ParameterActions>
        </StyledParametersList>
    )
}

const Cancel = styled.a`
    float: right;
    margin-top: 6px;
    font-size: 14px;
`

const ParameterActions = styled.div`
    border-top: 1px solid ${props => (props.dark ? '#172033' : 'var(--gray-300)')};
    padding: 10px;
    button {
        height: auto !important;
    }
`

export default ParametersList
// export default onClickOutside(ParametersList, {
//     handleClickOutside: () => ParametersList.toggle
// })
